export default {
  INBOX: "inbox",
  VIEW: "view",
  CREATE: "create",
  REPLY_OR_FORWARD: "replyOrForward",
  MATCH: "match",
  SHOW_SINGLE: "show_single",
};
